import React from 'react';
import { flattenHTMLToAppURL } from '@plone/volto/helpers';

const InEvidence = ({ content }) => {
  return content.testo_in_evidenza ? (
    <section className="in-evidence box">
      <div
        className="p-no-margin"
        dangerouslySetInnerHTML={{
          __html: flattenHTMLToAppURL(content.testo_in_evidenza.data),
        }}
      />
    </section>
  ) : (
    <></>
  );
};

export default InEvidence;
